import React from "react"
import * as overlayStyles from "./overlay.module.scss"

export default function Overlay(props) {
  return (
   <div className={(props.active ? `${[overlayStyles.overlay, overlayStyles.active].join(" ")}` : `${overlayStyles.overlay}`)}></div>
  )
}